module.exports = __webpack_public_path__ + "img/button_sort_desc.c7ad1bd3.png";